<template>
  <div>
    <!-- 头部 -->
    <div class="headerTop">
      <div class="EC_width display_between height_100">
        <div></div>
        <div class="display_center_ud">
          <div class="headerTop_search">
            <img src="/image/index/search.png" @click="onsearch()" />
            <input type="text" name="" id="" value="" v-model="keywords" />
          </div>
          <div class="headerTop_login" v-show="AuthorId == 0">
            <img src="/image/index/indexren.png" style="width:14px;height:16px" class="headerTop_login_img" />
            <a @click="userlogin()">登陆</a>
            <span style="color: #fff; margin: 0 6px">|</span>
            <a @click="userRegister()">注册</a>
          </div>
          <div class="headerTop_login" v-show="AuthorId > 0" v-if="authorinfo != null">
            <router-link to="/user/userMymsg">
              <img src="/image/index/lingdangset.png" alt="" class="headerTop_login_img" />
              <span class="msgnum" v-show="unreadmsg > 0">{{ unreadmsg }}</span>
            </router-link>
            <!-- </a> -->
            <div @click.capture="taggleinfor = true" style="cursor: pointer;position: relative;">
              <img class="headerTop_login_img" :src="authorinfo.avatarUrl" alt=""
                style="vertical-align: -4px; border-radius: 50%" width="24" height="24" />
              <img src="../../assets/img/v.png" class="viplogpo" alt="" v-if="userType == 2" />
              <img src="../../assets/img/s.png" class="viplogpo" alt="" v-if="userType == 1" />
              <span style="color: #fff">{{ authorinfo.nickname != '' ? authorinfo.nickname : authorinfo.mobile }}</span>
            </div>
            <div class="opra" v-show="taggleinfor" @click.stop="setClick">
              <div class="text_right" style="position: relative;">
                <img src="/image/index/shangjiao.png" alt="" class="ArrowTop" />
              </div>

              <div class="display_flex">
                <!-- <img src="/image/index/stateHead.png" /> -->
                <img :src="authorinfo.avatarUrl" @click="$router.push({ name: 'userInfor' })" class="img-border" />
                <div class="flex1 marginLeft10">
                  <p class="marginTop10 marginBottom10">
                    {{ authorinfo.nickname != '' ? authorinfo.nickname : authorinfo.mobile }}
                    <router-link to="/user/userMyInforShow">
                      <span class="informy" style="cursor: pointer">
                        个人资料
                      </span>
                    </router-link>
                    <!-- </a> -->
                  </p>
                  <p>
                    <img src="/image/index/phoneIcon.png" alt="" />
                    {{ authorinfo.mobile }}
                  </p>
                </div>
                <div>
                  <span class="out" @click="out">退出</span>
                </div>
              </div>
              <div class="vip display_between marginTop20">
                <div v-if="userType == 0" class="display_center_ud">
                  <img src="../../assets/img/svip.png" style="width:38px" alt="" />
                  <span class="marginLeft10 redColor">全站通-198元</span>
                  <span>/年</span>
                </div>
                <div v-else class="display_center_ud">
                  <img style="width:38px" src="../../assets/img/svip.png" alt="" />
                  <span class="marginLeft10 redColor" style="font-size:14px">{{ userType == 1 ? 'SVIP' : 'VIP' }}到期时间：{{
                    authorinfo.memberDate.m_EndDate.substr(0, 10) }}</span>
                </div>
                <div class="kaitong">
                  <span v-if="userType == 0" style="cursor: pointer">
                    <router-link to="/user/userVip">
                      立即开通
                    </router-link>
                  </span>
                  <span v-else-if="userType == 1" style="cursor: pointer">
                    <router-link to="/user/userVip">
                      立即续费
                    </router-link>
                  </span>
                  <span v-else-if="userType == 2" style="cursor: pointer">
                    <router-link to="/user/userVip">
                      立即升级
                    </router-link>
                  </span>
                </div>
              </div>
              <div class="display_between marginTop20">
                <div class="display_column display_center" style="cursor: pointer">
                  <router-link to="/user/userMyOrder" style="display:flex;flex-direction: column;align-items: center;">
                    <img src="/image/index/menu01.png" alt="" />
                    <div class="marginTop10" style="color:black">我的订单</div>
                  </router-link>
                </div>
                <div class="display_column display_center" style="cursor: pointer">
                  <router-link to="/user/userMyCourse" style="display:flex;flex-direction: column;align-items: center;">
                    <img src="/image/index/menu02.png" alt="" />
                    <div class="marginTop10" style="color:black">我的课程</div>
                  </router-link>
                </div>
                <div class="display_column display_center" style="cursor: pointer">
                  <router-link to="/user/userMyCollection"
                    style="display:flex;flex-direction: column;align-items: center;">
                    <img src="/image/index/menu03.png" alt="" />
                    <div class="marginTop10" style="color:black">我的收藏</div>
                  </router-link>
                </div>
                <div class="display_column display_center" style="cursor: pointer">
                  <router-link to="/user/userVip" style="display:flex;flex-direction: column;align-items: center;">
                    <img src="/image/index/menu04.png" alt="" />
                    <div class="marginTop10" style="color:black">VIP中心</div>
                  </router-link>
                </div>
                <div class="display_column display_center" style="cursor: pointer">
                  <router-link to="/user/userMyMeeting"
                    style="display:flex;flex-direction: column;align-items: center;">
                    <img src="/image/index/menu05.png" alt="" />
                    <div class="marginTop10" style="color:black">我的会议</div>
                  </router-link>
                </div>
              </div>
            </div>
            <div class="modal" v-if="taggleinfor" @click="taggleinfor = false"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="header EC_width display_between">
      <div class="logoWrap display_center_ud">
        <img src="/image/logo.png" />
      </div>
      <div class="display_flex" style="font-size: 18px">
        <div class="menu_item" :class="{ menu_item_active: currentindex == 1 }">
          <a href="javascript:void(0)" @click="$router.push({ name: 'home' })">网站首页</a>
        </div>
        <div class="menu_item">
          <a :href="httphelper.IsDebugCgphome() + '/home'" target="_blank">
            全科知家
          </a>
        </div>
        <div class="menu_item">
          <a :href="httphelper.IsDebugCgphome() + '/AllCourse'" target="_blank">
            全部课程
          </a>
        </div>
        <div class="menu_item" :class="{ menu_item_active: currentindex == 6 }">
          <a href="javascript:void(0)" @click="$router.push({ name: 'experts' })">专家知家</a>
        </div>
        <div class="menu_item" :class="{ menu_item_active: currentindex == 7 }">
          <a href="javascript:void(0)" @click="$router.push({ name: 'organization' })">机构知家</a>
        </div>
        <div class="menu_item">
          <a href="javascript:void(0)" @click="toPage">秒知医技</a>
        </div>
        <div class="menu_item">
          <a href="javascript:void(0)" @click="toPage">华佗视频</a>
        </div>
        <div class="menu_item">
          <a href="javascript:void(0)" @click="toPage">每周会诊</a>
        </div>
      </div>
      <div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'header_index',
  data() {
    return {
      currentindex: 0,
      taggleinfor: false,
      loginStaus: false,
      authorinfo: null,
      keywords: '',
      AuthorId: 0,
      isDebug: true,
      isseach: true,
      unreadmsg: 0,
      userType: 0
    };
  },
  watch: {
    $route(to) {
      if (to.meta.activeNum != undefined) {
        // alert(to.meta.activeNum);
        this.currentindex = to.meta.activeNum;
      }
      if (to.name != 'searchPage') {
        // alert(to.meta.activeNum);
        this.isseach = true
      } else {
        this.isseach = false
      }
    }
  },
  created() {
    if (this.$route.name != 'searchPage') {
      // alert(to.meta.activeNum);
      this.isseach = true
    } else {
      this.isseach = false
    }
  },
  mounted() {
    if (this.$route.meta.activeNum != undefined) {
      this.currentindex = this.$route.meta.activeNum;
    }

    // if (localStorage.getItem('ResData')) {
    //     this.loginStaus = true;
    //     this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
    //     this.authorinfo = JSON.parse(localStorage.getItem('ResData'));
    // } else if (this.$cookies.isKey('token_chinagp')) {
    //     if (this.checkToken()) {
    //         this.loginStaus = true;
    //         this.AuthorId = JSON.parse(localStorage.getItem('ResData')).id;
    //         this.authorinfo = JSON.parse(localStorage.getItem('ResData'));
    //     }
    // }
    if (this.$cookies.isKey('token_chinagp')) {
      var _tokenkey = this.$cookies.get('token_chinagp');
      this.httphelper
        .post('/api/LoginApi/CheckToken', {
          tokenKey: _tokenkey
        })
        .then(res => {
          if (res.data.code == 200) {
            localStorage.setItem('nickname', res.data.data.nickname);
            localStorage.setItem('ResData', JSON.stringify(res.data.data));
            var aData = new Date();
            var CurrentDategetTime = 0
            var VipEdDategetTime = 0
            if (res.data.data.memberDate.m_EndDate) {
              var CurrentDate = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
              var VipEdDate = res.data.data.memberDate.m_EndDate;
              CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
              VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
            }
            if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
              this.userType = 0;
            } else {
              if (res.data.data.memberDate.m_Type == 1) {
                this.userType = 1;
              } else if (res.data.data.memberDate.m_Type == 2) {
                this.userType = 2;
              } else {
                this.userType = 0;
              }
            }
            localStorage.setItem('userType', this.userType);
            this.loginStaus = true;
            this.AuthorId = res.data.data.id;
            this.authorinfo = res.data.data;
            // window.location.reload();
            this.httphelper
              .post('/api/MessageApi/GetNewMessageCount', {
                userId: this.AuthorId,
              })
              .then(res => {
                this.unreadmsg = res.data.data;
              });
          } else {
            localStorage.removeItem('nickname');
            localStorage.removeItem('ResData');
            localStorage.removeItem('userType');
            // localStorage.clear();
            this.$cookies.remove('token_chinagp');
            // window.location.reload();
          }
        });
    } else {
      // localStorage.clear();
      localStorage.removeItem('nickname');
      localStorage.removeItem('ResData');
      localStorage.removeItem('userType');
      this.$cookies.remove('token_chinagp');
      // window.location.reload();
    }
  },
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    next(vm => {
      if (to.meta.activeNum != undefined) {
        vm.currentindex = to.meta.activeNum;
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (to.meta.activeNum != undefined) {
      this.currentindex = to.meta.activeNum;
    }
    next();
  },
  methods: {
    setClick() { },

    out() {
      this.taggleinfor = false;
      this.loginStaus = false;
      this.AuthorId = 0;
      this.outClearToken();
    },
    userlogin() {
      let routeUrl = this.$router.resolve({
        path: '/loginIndex/login'
      });
      window.location.href = routeUrl.href;
      //   window.open(routeUrl.href, '_blank')
    },
    userRegister() {
      // this.taggleinfor=true
      let routeUrl = this.$router.resolve({
        path: '/loginIndex/loginRegister'
      });
      window.location.href = routeUrl.href;
      //   window.open(routeUrl.href, '_blank')
    },
    onsearch() {
      this.$router.push({
        name: 'searchPage',
        params: { labelname: this.keywords }
      });
    },
    navclick() {
      this.$msgmodal({
        title: '系统提示',
        content: '建设中...',
        type: 'warn'
      });
    },
    outClearToken() {
      var _tokenkey = this.$cookies.get('token_chinagp');
      this.httphelper.post('/api/LoginApi/ClearToken', {
        tokenKey: _tokenkey
      })
        .then(res => {
          if (res.data.code == 200) {
            localStorage.clear();
            this.$cookies.remove('token_chinagp');
            location.reload();
          }
        })
    },
    checkToken() {
      var _tokenkey = this.$cookies.get('token_chinagp');
      this.httphelper
        .post('/api/LoginApi/CheckToken', {
          tokenKey: _tokenkey
        })
        .then(res => {
          if (res.data.code == 200) {
            localStorage.setItem('nickname', res.data.data.nickname);
            var aData = new Date();
            var CurrentDategetTime = 0
            var VipEdDategetTime = 0
            if (res.data.data.memberDate.m_EndDate) {
              var CurrentDate = aData.getFullYear() + '-' + (aData.getMonth() + 1) + '-' + aData.getDate() + ' ' + aData.getHours() + ':' + aData.getMinutes() + ':' + aData.getSeconds();
              var VipEdDate = res.data.data.memberDate.m_EndDate;
              CurrentDategetTime = new Date(CurrentDate.replace(/-/g, '/')).getTime() / 1000;
              VipEdDategetTime = new Date(VipEdDate.replace(/-/g, '/')).getTime() / 1000;
            }
            if (res.data.data.memberDate.m_EndDate == null || parseInt(CurrentDategetTime) - parseInt(VipEdDategetTime) >= 0) {
              this.userType = 0;
            } else {
              if (res.data.data.memberDate.m_Type == 1) {
                this.userType = 1;
              } else if (res.data.data.memberDate.m_Type == 2) {
                this.userType = 2;
              } else {
                this.userType = 0;
              }
            }
            localStorage.setItem('userType', this.userType);
            localStorage.setItem('ResData', JSON.stringify(res.data.data));
            return true;
          }
          return false;
        });
    },
    toPage() {
      this.$alert('建设中...', '提示', {
        confirmButtonText: '确定',
      });
    }
  }
};
</script>

<style scoped>
/* 页面的顶部搜索条 */
.headerTop {
  height: 34px;
  background: linear-gradient(90deg, #0e3853, #01787a);
  min-width: 1240px;
}

.headerTop_home {
  color: #fff;
  font-size: 14px;
}

.headerTop_search {
  position: relative;
}

.headerTop_search input {
  width: 200px;
  height: 26px;
  outline: none;
  border-radius: 26px;
  box-sizing: border-box;
  padding-left: 20px;
}

.headerTop_search img {
  position: absolute;
  right: 13px;
  top: 4px;
  cursor: pointer;
}

.headerTop_login {
  position: relative;
  display: flex;
}

.headerTop_login a {
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}

.headerTop_login_img {
  margin-left: 20px;
  margin-right: 6px;
  vertical-align: -2px;
}

/* 头部样式 */
.header {
  height: 90px;
  display: flex;
  min-width: 1240px;
}

.logoWrap {
  width: 190px;
}

.menu_item {
  padding: 0 20px;
  line-height: 90px;
  overflow: hidden;
  box-sizing: border-box;
}

.menu_item_style {
  padding: 0 20px;
  line-height: 90px;
  box-sizing: border-box;
}

.menu_item_style a {
  width: 80px;
  height: 34px;
  color: #fff;
  line-height: 34px;
  text-align: center;
  display: inline-block;
  border-radius: 36px;
  background: #b70109;
}

.menu_item a {
  color: #333;
  /* font-weight: bold; */
  white-space: nowrap;
}

.menu_item_active {
  border-bottom: 3px solid #0b8485;
}

.menu_item_active a {
  color: #0b8485;
  font-weight: bold;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
}

.opra {
  padding: 25px;
  display: inline-block;
  position: absolute;
  background: #fff;
  width: 400px;
  box-sizing: border-box;
  right: 0px;
  top: 29px;
  box-shadow: 0px 5px 15px 0px rgba(6, 50, 52, 0.2);
  border-radius: 3px;
  z-index: 100;
}

.out {
  padding: 2px 8px;
  border: 1px solid #c8c8c8;
  border-radius: 10px;
  cursor: pointer;
}

.informy {
  width: 77px;
  height: 25px;
  background: #0b8586;
  border-radius: 13px;
  display: inline-block;
  text-align: center;
  line-height: 25px;
  color: #fff;
  margin-left: 5px;
}

.vip {
  height: 50px;
  background: url('/image/index/gerenbar.png');
  padding: 0 6px;
}

.kaitong {
  width: 96px;
  height: 29px;
  background: linear-gradient(90deg, #ff1e00, #ff6600);
  border-radius: 14px;
  text-align: center;
  line-height: 29px;
  color: #fff;
}

.ArrowTop {
  position: absolute;
  top: -30px;
}

.img-border {
  border-radius: 30px;
  -webkit-border-radius: 30px;
  -moz-border-radius: 30px;
  width: 60px;
  height: 60px;
  cursor: pointer;
}

.viplogpo {
  width: 14px;
  height: 17px;
  position: absolute;
  left: 37px;
  top: -5px;
  z-index: 9;
}

.msgnum {
  position: absolute;
  left: 35px;
  top: -5px;
  background-color: rgb(207, 19, 19);
  color: #fff;
  padding: 0px 2px 1px;
  border-radius: 8px;
}
</style>